<template>
  <div>
    <Menu />
    <div class="container main">
      <pulse-loader
        :loading="loading"
        :color="color"
        :size="size"
        class="vue-loader"
      ></pulse-loader>
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Resultado Indicadores"
            description="Série histórica dos Indicadores nós últimos 12 meses"
            url="/indicadores-aps"
          />
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <vue-select
              :clearable="false"
              :options="equipes"
              label="no_equipe"
              placeholder="Equipes"
              @input="onChangeEquipe"
            >
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="box mt-0">
            <div class="box-header">
              <h4 class="box-title">
                <i class="icofont-chart-bar-graph"></i> Série Histórica
              </h4>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-lg-12">
                  <apexchart
                    type="line"
                    height="480"
                    :options="chartOptions"
                    :series="chartData"
                    ref="chartData"
                  ></apexchart>
                  <div class="tabela-container">
                    <table class="tabela">
                      <thead>
                        <tr>
                          <th class="sem-borda"></th>
                          <th v-for="categoria in xaxis" :key="categoria.index">
                            {{ categoria }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(
                            serieMunicipioEquipe, index
                          ) in arrayChartData"
                          :key="`${index} + ${serieMunicipioEquipe}`"
                        >
                          <td class="titulo_td">
                            <div class="container-barrinha">
                              <span
                                class="barrinha"
                                :style="{
                                  background: chartOptions.colors[index],
                                }"
                              ></span>
                            </div>
                            <span class="municipio">{{
                              serieMunicipioEquipe.name
                            }}</span>
                          </td>

                          <td
                            v-for="(serie, index) in serieMunicipioEquipe.data"
                            :key="`${index} + ${serie}`"
                          >
                            {{ serie }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import Loader from '@/components/Loader'
import SectionTitle from '@/components/SectionTitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import axios from 'axios'

export default {
  name: 'ResultadoIndicadores',
  metaInfo: {
    title: 'eSUS Feedback - Resultado Indicadores',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    Loader,
    SectionTitle,
    PulseLoader,
    apexchart: VueApexCharts,
  },
  created() {
    this.init()
  },
  data() {
    return {
      cod_ibge: '',
      equipe: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
      chartData: [],
      arrayChartData: null,
      xaxis: null,
      chartOptions: {
        chart: {
          height: 300,
          type: 'line',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
          width: 2,
        },
        title: {
          text: 'RESULTADO MUNICIPAL, ' + this.$store.getters.getCidade,
          align: 'center',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
          // type: 'category'
        },
        yaxis: {
          min: 0,
          // max: 100
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'center',
        },
        markers: {
          size: 5,
        },
        annotations: {
          // yaxis: [
          //     {
          //         y: 50,
          //         y2: 100,
          //         borderColor: '',
          //         fillColor: '#b3ffb3',
          //         label: {
          //             text: ''
          //         }
          //     },
          //     {
          //         y: 0,
          //         y2: 49,
          //         borderColor: '',
          //         fillColor: '#ffcccc',
          //         label: {
          //             text: ''
          //         }
          //     }
          // ]
        },
        colors: [
          '#008FFB',
          '#ff9933',
          '#FF0000',
          '#009933',
          '#ffff00',
          '#000000',
          '#ff33cc',
        ],
      },
    }
  },
  computed: {
    equipes() {
      let data = this.$store.getters['getEquipes']
      data.unshift({
        nu_ine: 'municipio',
        no_equipe: 'MUNICÍPIO',
      })
      return data
    },
  },
  methods: {
    async carregarResultadosPorMunicipio() {
      this.loading = true

      let consultas_pre_natal = await this.$api.get(
        '/app/serie-historica/municipio/' + this.cod_ibge + '/1'
      )

      let exames_hiv_sifilis = await this.$api.get(
        '/app/serie-historica/municipio/' + this.cod_ibge + '/2'
      )

      let consultas_odontologicas = await this.$api.get(
        '/app/serie-historica/municipio/' + this.cod_ibge + '/3'
      )

      let indicador_citologico = await this.$api.get(
        '/app/serie-historica/municipio/' + this.cod_ibge + '/4'
      )

      let indicador_imunizacao = await this.$api.get(
        '/app/serie-historica/municipio/' + this.cod_ibge + '/5'
      )

      let atendimento_hipertensao = await this.$api.get(
        '/app/serie-historica/municipio/' + this.cod_ibge + '/6'
      )

      let hemoglobina_glicada = await this.$api.get(
        '/app/serie-historica/municipio/' + this.cod_ibge + '/7'
      )

      axios
        .all([
          consultas_pre_natal,
          exames_hiv_sifilis,
          consultas_odontologicas,
          indicador_citologico,
          indicador_imunizacao,
          atendimento_hipertensao,
          hemoglobina_glicada,
        ])
        .then(
          axios.spread((...responses) => {
            // console.log(responses)

            let array_xaxis = []
            // pega o maior array
            let tam_maior_array = 0
            let indice_maior_array = 0
            for (let i = 0; i < 6; i++) {
              if (responses[i].data.length > tam_maior_array) {
                tam_maior_array = responses[i].data.length
                indice_maior_array = i
              }
            }
            //preencher a legenda
            for (const item of responses[indice_maior_array].data) {
              array_xaxis.push(item.mes_ano)
            }

            let array_chart_pre_natal = [],
              array_chart_hiv_sifilis = [],
              array_chart_consultas_odontologicas = [],
              array_chart_citologico = [],
              array_chart_imunizacao = [],
              array_chart_hipertensao = [],
              array_chart_hemoglobina = []

            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[0].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_pre_natal.push(resultado)
            }
            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[1].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_hiv_sifilis.push(resultado)
            }
            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[2].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_consultas_odontologicas.push(resultado)
            }
            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[3].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_citologico.push(resultado)
            }
            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[4].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_imunizacao.push(resultado)
            }
            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[5].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_hipertensao.push(resultado)
            }
            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[6].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_hemoglobina.push(resultado)
            }
            this.xaxis = array_xaxis
            this.$refs.chartData.updateOptions({
              xaxis: {
                categories: array_xaxis,
              },
              title: {
                text: 'RESULTADO MUNICIPAL, ' + this.$store.getters.getCidade,
              },
            })
            this.$refs.chartData.updateSeries([
              {
                name: 'Consultas pré-natal',
                data: array_chart_pre_natal,
              },
              {
                name: 'Exames HIV e Sífilis',
                data: array_chart_hiv_sifilis,
              },
              {
                name: 'Consultas odontológicas',
                data: array_chart_consultas_odontologicas,
              },
              {
                name: 'Citopatológico',
                data: array_chart_citologico,
              },
              {
                name: 'Vacinas',
                data: array_chart_imunizacao,
              },
              {
                name: 'Hipertensão',
                data: array_chart_hipertensao,
              },
              {
                name: 'Diabéticos',
                data: array_chart_hemoglobina,
              },
            ])
            this.arrayChartData = [
              {
                name: 'Consultas pré-natal',
                data: array_chart_pre_natal,
              },
              {
                name: 'Exames HIV e Sífilis',
                data: array_chart_hiv_sifilis,
              },
              {
                name: 'Consultas odontológicas',
                data: array_chart_consultas_odontologicas,
              },
              {
                name: 'Citopatológico',
                data: array_chart_citologico,
              },
              {
                name: 'Vacinas',
                data: array_chart_imunizacao,
              },
              {
                name: 'Hipertensão',
                data: array_chart_hipertensao,
              },
              {
                name: 'Diabéticos',
                data: array_chart_hemoglobina,
              },
            ]
            this.loading = false
          })
        )

        .catch((errors) => {
          // react on errors.
          console.error(errors)
        })
    },

    async onChangeEquipe(event) {
      if (event.nu_ine == 'municipio') {
        this.carregarResultadosPorMunicipio()
      } else {
        this.equipe = event.nu_ine
        this.carregarResultadosPorEquipe(this.equipe, event.no_equipe)
      }
    },

    async carregarResultadosPorEquipe(nu_ine, no_equipe) {
      this.loading = true

      let consultas_pre_natal = await this.$api.get(
        '/app/serie-historica/equipe/' + this.cod_ibge + '/' + nu_ine + '/1'
      )

      let exames_hiv_sifilis = await this.$api.get(
        '/app/serie-historica/equipe/' + this.cod_ibge + '/' + nu_ine + '/2'
      )

      let consultas_odontologicas = await this.$api.get(
        '/app/serie-historica/equipe/' + this.cod_ibge + '/' + nu_ine + '/3'
      )

      let indicador_citologico = await this.$api.get(
        '/app/serie-historica/equipe/' + this.cod_ibge + '/' + nu_ine + '/4'
      )

      let indicador_imunizacao = await this.$api.get(
        '/app/serie-historica/equipe/' + this.cod_ibge + '/' + nu_ine + '/5'
      )

      let atendimento_hipertensao = await this.$api.get(
        '/app/serie-historica/equipe/' + this.cod_ibge + '/' + nu_ine + '/6'
      )

      let hemoglobina_glicada = await this.$api.get(
        '/app/serie-historica/equipe/' + this.cod_ibge + '/' + nu_ine + '/7'
      )

      axios
        .all([
          consultas_pre_natal,
          exames_hiv_sifilis,
          consultas_odontologicas,
          indicador_citologico,
          indicador_imunizacao,
          atendimento_hipertensao,
          hemoglobina_glicada,
        ])
        .then(
          axios.spread((...responses) => {
            // console.log(responses)

            let array_xaxis = []
            // pega o maior array
            let tam_maior_array = 0
            let indice_maior_array = 0
            for (let i = 0; i < 6; i++) {
              if (responses[i].data.length > tam_maior_array) {
                tam_maior_array = responses[i].data.length
                indice_maior_array = i
              }
            }
            //preencher a legenda
            for (const item of responses[indice_maior_array].data) {
              array_xaxis.push(item.mes_ano)
            }

            let array_chart_pre_natal = [],
              array_chart_hiv_sifilis = [],
              array_chart_consultas_odontologicas = [],
              array_chart_citologico = [],
              array_chart_imunizacao = [],
              array_chart_hipertensao = [],
              array_chart_hemoglobina = []

            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[0].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_pre_natal.push(resultado)
            }
            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[1].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_hiv_sifilis.push(resultado)
            }
            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[2].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_consultas_odontologicas.push(resultado)
            }
            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[3].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_citologico.push(resultado)
            }
            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[4].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_imunizacao.push(resultado)
            }
            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[5].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_hipertensao.push(resultado)
            }
            for (let i = 0; i < array_xaxis.length; i++) {
              var eixo_x_atual = array_xaxis[i]
              for (const item of responses[6].data) {
                var resultado = 0
                if (item.mes_ano == eixo_x_atual) {
                  resultado = item.resultado
                  break
                } else {
                  resultado = null
                }
              }
              array_chart_hemoglobina.push(resultado)
            }
            this.xaxis = array_xaxis
            this.$refs.chartData.updateOptions({
              xaxis: {
                categories: array_xaxis,
              },
              title: {
                text: 'RESULTADO DA EQUIPE ' + no_equipe.toUpperCase(),
              },
            })

            this.$refs.chartData.updateSeries([
              {
                name: 'Consultas pré-natal',
                data: array_chart_pre_natal,
              },
              {
                name: 'Exames HIV e Sífilis',
                data: array_chart_hiv_sifilis,
              },
              {
                name: 'Consultas odontológicas',
                data: array_chart_consultas_odontologicas,
              },
              {
                name: 'Citopatológico',
                data: array_chart_citologico,
              },
              {
                name: 'Vacinas',
                data: array_chart_imunizacao,
              },
              {
                name: 'Hipertensão',
                data: array_chart_hipertensao,
              },
              {
                name: 'Diabéticos',
                data: array_chart_hemoglobina,
              },
            ])
            this.arrayChartData = [
              {
                name: 'Consultas pré-natal',
                data: array_chart_pre_natal,
              },
              {
                name: 'Exames HIV e Sífilis',
                data: array_chart_hiv_sifilis,
              },
              {
                name: 'Consultas odontológicas',
                data: array_chart_consultas_odontologicas,
              },
              {
                name: 'Citopatológico',
                data: array_chart_citologico,
              },
              {
                name: 'Vacinas',
                data: array_chart_imunizacao,
              },
              {
                name: 'Hipertensão',
                data: array_chart_hipertensao,
              },
              {
                name: 'Diabéticos',
                data: array_chart_hemoglobina,
              },
            ]
            this.loading = false
          })
        )
        .catch((errors) => {
          // react on errors.
          console.error(errors)
        })
    },

    init() {
      this.cod_ibge = this.$store.state.cod_ibge
      this.carregarResultadosPorMunicipio()
    },
  },
}
</script>
<style scoped>
.tabela-container {
  overflow-x: scroll;
}

.tabela {
  margin: 60px auto;
}

th,
td {
  padding: 5px 10px;
  text-align: center;
  border: 1px solid #e8e8e8;
}
td:first-child {
  border-top: unset;
  border-right: unset;
}
th:first-child {
  border-top: unset;
  border-left: unset;
}
.barrinha {
  min-width: 10px;
  height: 10px;
  display: block;
  border-radius: 10px;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
}
.titulo_td {
  display: flex;
  align-items: center;
  gap: 5px;
}
.sem-borda {
}
thead {
  border-top: unset;
  border-left: unset;
}
.municipio {
  text-align: initial;
}
.container-barrinha {
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
